import { useEffect, useState } from "react";
import {
  getStoredAdminUser,
  logoutAdmin,
  subscribeToAdminAuth,
  updateStoredAdminProfile,
} from "../store/api/authApi";

export const useAdminAuth = () => {
  const [adminUser, setAdminUser] = useState(() => getStoredAdminUser());

  useEffect(() => {
    const syncAdminUser = () => {
      setAdminUser(getStoredAdminUser());
    };

    return subscribeToAdminAuth(syncAdminUser);
  }, []);

  return {
    adminUser,
    logout: logoutAdmin,
    updateProfile: updateStoredAdminProfile,
  };
};
